import { Col, Row } from 'antd'
import { FC, useEffect } from 'react'
import { getBadges } from '../../util/getBadges'
import Styles from './BadgeDetails.module.scss'
import { BitazzaText, LeaderBoardLayout } from '../../components'
import { appCallbackHandler } from '../../util/AppCallbackHandler'
import { useTranslation } from 'react-i18next'

export const BadgeDetails: FC<unknown> = () => {
    const { t } = useTranslation()
    const DATA = [
        {
            id: 1,
            name: 'Bronze',
            des: t('txt_below_avr'),
        },
        {
            id: 2,
            name: 'Silver',
            des: `${t('txt_higher_than')} 50% ${t('txt_of_trader')}`,
        },
        {
            id: 3,
            name: 'Gold',
            des: `${t('txt_higher_than')} 80% ${t('txt_of_trader')}`,
        },
        {
            id: 4,
            name: 'Platinum',
            des: `${t('txt_higher_than')} 95% ${t('txt_of_trader')}`,
        },
    ]

    useEffect(() => {
        appCallbackHandler('setToolbarHeaderUI', 'Badge Details')
    }, [])
    return (
        <LeaderBoardLayout headerText="Prize Pool" isSeasonHeaderHidden>
            <div className={Styles.wrapper}>
                {DATA.map((item) => (
                    <Row
                        className={Styles.container}
                        key={item.id}
                        align="middle"
                    >
                        <Col span={6}>
                            <img
                                src={getBadges(item.name)}
                                alt="badge"
                                width={66}
                            />
                        </Col>
                        <Col span={18}>
                            <Row align="middle">
                                <Col span={24}>
                                    <BitazzaText
                                        color="#F1D87E"
                                        content={item.name}
                                        format="t20"
                                        semiBold
                                    />
                                </Col>
                                <Col span={24}>
                                    <BitazzaText
                                        color="#FFF"
                                        content={item.des}
                                        format="t16"
                                    />
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                ))}
            </div>
            <div className={Styles.textWrapper}>
                <BitazzaText
                    content={t('txt_badge_note')}
                    color="#86A1A1"
                    format="t16"
                    textAlign="center"
                />
            </div>
        </LeaderBoardLayout>
    )
}
